import React from 'react';
import { FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

const ContactUs = () => {
  return (
    <div className="contactus-wrapper">
      <Helmet>
        <title>Contact Us | Pravisht</title>
      </Helmet>

      <section>
        <div className="breadcrumb">
          <a href="/" className="mx-1">Home</a> &gt;  
          <span className="mx-1">Contact Us</span>
        </div>

        <div className="section-header">
          <div className="contact-container">
            <h2>Contact Us</h2>
            <p>
              We’d love to hear from you! Whether you have a question about our solutions,
              need support, or just want to explore how Pravisht can help your organization—
              our team is here for you.
            </p>
          </div>
        </div>

        <div className="contact-container">
          <div className="row contact-content">

            {/* UPDATED ADDRESS SECTION */}
           <div className="contact-info">

  {/* India */}
  <div className="location-block">
    <h4 className="country-title">
    India (Head Office)
    </h4>

    <div className="address"> 
     <FaHome className="icon"/>
     <p>H-91, H Block, Sector-63 Noida, UP-201301, India</p>
    </div>

    <div className="contact-row">
      <FaPhone className="icon" />
      <span>+1 470 666 8431</span>
    
      <FaEnvelope className="icon" />
      <span>Sales@pravisht.com</span>
    </div>
  </div>

  {/* Divider */}
  <hr className="divider" />

  {/* UK */}
  <div className="location-block">
    <h4 className="country-title">
    United Kingdom
    </h4>

    <div className="address"> 
     <FaHome className="icon"/>
     <p>20 Wenlock Road, London, England, N1 7GU</p>
    </div>

    <div className="contact-row">
      <FaPhone className="icon" />
      <span>+44 7774 914157</span>
  
      <FaEnvelope className="icon" />
      <span>Sales@pravisht.com</span>
    </div>
  </div>

</div>

            {/* FORM SAME */}
            <div className="contact-form">
              <form id="contact-form">
                <h2>Send Message</h2>

                <div className="input-box">
                  <input type="text" required />
                  <span>Full Name</span>
                </div>

                <div className="input-box">
                  <input type="email" required />
                  <span>Email</span>
                </div>

                <div className="input-box">
                  <textarea required></textarea>
                  <span>Type your Message...</span>
                </div>

                <div className="input-box">
                  <input type="submit" value="Send" />
                </div>
              </form>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;